import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import Tooltip from '@mui/material/Tooltip';

import { getLinkLtik } from 'constants/LTIData';

import classes from './AudioIconProgress.module.css';

const url = window.location.pathname.split('/');

const AudioIconProgress = props => {
  return (
    <Tooltip placement="bottom" title="Audio">
      <Link
        to={
          getLinkLtik()
            ? `/aud/${props.data.idCourse}/${
                props.data.idVideo
              }/?ltik=${getLinkLtik()}`
            : url[2] === 'a'
            ? `/a/aud/${props.data.idCourse}/${props.data.idVideo}`
            : url[2] === 'course'
            ? `/course/aud/${props.data.idCourse}/${props.data.idVideo}`
            : `/aud/${props.data.idCourse}/${props.data.idVideo}`
        }
        className={`${classes.productLesson} ${
          !props.accessCourse ? classes.productLessonDisabled : ''
        }`}
      >
        {props.accessCourse && (
          <VolumeUpOutlinedIcon className={classes.audioIcon} />
        )}
        <p className={classes.noDisplay}>.</p>
      </Link>
    </Tooltip>
  );
};

AudioIconProgress.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  userTrack: PropTypes.object
};

export default AudioIconProgress;
